module.exports = __webpack_public_path__ + "img/yszc-sj-2x.f9f276a5.png";